/**
 * Параметр отвечающий за отображение нового вида поисковых подсказок.
 */
export const isNewSearchTipsEnabled = window.app && window.app.isNewSearchTipsEnabled
